(function () {
  function initWeldResultsMarquee(root) {
    if (!root || root.dataset.wrmReady === 'true') return;
    root.dataset.wrmReady = 'true';

    var marquees = root.querySelectorAll('[data-wrm-marquee]');
    if (!marquees.length) return;

    var instances = [];

    marquees.forEach(function (marquee) {
      var track = marquee.querySelector('[data-wrm-marquee-track]');
      var sourceGroup = marquee.querySelector('[data-wrm-marquee-source]');
      var cloneGroup = marquee.querySelector('[data-wrm-marquee-clone]');

      if (!track || !sourceGroup || !cloneGroup) return;

      var originalMarkup = sourceGroup.innerHTML.trim();
      if (!originalMarkup) return;

      instances.push({
        marquee: marquee,
        track: track,
        sourceGroup: sourceGroup,
        cloneGroup: cloneGroup,
        originalMarkup: originalMarkup
      });
    });

    if (!instances.length) return;

    var frameId = null;

    function buildMarquee(instance) {
      var marquee = instance.marquee;
      var track = instance.track;
      var sourceGroup = instance.sourceGroup;
      var cloneGroup = instance.cloneGroup;
      var originalMarkup = instance.originalMarkup;

      sourceGroup.innerHTML = originalMarkup;
      cloneGroup.innerHTML = '';

      var containerWidth = marquee.clientWidth;
      if (!containerWidth) return;

      var sourceWidth = sourceGroup.scrollWidth;
      var safety = 0;

      while (sourceWidth > 0 && sourceWidth < containerWidth && safety < 12) {
        sourceGroup.insertAdjacentHTML('beforeend', originalMarkup);
        sourceWidth = sourceGroup.scrollWidth;
        safety += 1;
      }

      cloneGroup.innerHTML = sourceGroup.innerHTML;

      var sourceRect = sourceGroup.getBoundingClientRect();
      var cloneRect = cloneGroup.getBoundingClientRect();
      var marqueeDistance = cloneRect.left - sourceRect.left;

      track.style.setProperty('--wrm-marquee-distance', marqueeDistance + 'px');
    }

    function buildAll() {
      instances.forEach(buildMarquee);
    }

    function queueBuild() {
      if (frameId) window.cancelAnimationFrame(frameId);
      frameId = window.requestAnimationFrame(buildAll);
    }

    root.querySelectorAll('.wrm__image').forEach(function (image) {
      if (!image.complete) {
        image.addEventListener('load', queueBuild, { once: true });
      }
    });

    if (typeof ResizeObserver === 'function') {
      var resizeObserver = new ResizeObserver(queueBuild);
      instances.forEach(function (instance) {
        resizeObserver.observe(instance.marquee);
      });
    } else {
      window.addEventListener('resize', queueBuild);
    }

    if (document.readyState === 'complete') {
      queueBuild();
    } else {
      window.addEventListener('load', queueBuild, { once: true });
      queueBuild();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.contains(root)) queueBuild();
    });

    document.addEventListener('shopify:section:reorder', queueBuild);
    document.addEventListener('shopify:block:select', function (event) {
      if (event.target && event.target.closest('[data-wrm-root]')) queueBuild();
    });
  }

  function boot() {
    document.querySelectorAll('[data-wrm-root]').forEach(initWeldResultsMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
